// extracted by mini-css-extract-plugin
export default {"wrapper":"_e5f4f42f","tabWrapper":"_35b60df8","activeTab":"_aafacca7","tabIcon":"_cd16e120","tabCount":"_344a7f68","tabLabel":"_d160408d"};